export class ChangeHighlight {

    name: string;
    value: string;

    constructor(changeHighlight: IChangeHighlight) {
        this.name = changeHighlight.name;
        this.value = changeHighlight.value;
    }
}

export interface IChangeHighlight {

    name: string;
    value: string;
}